import React, { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import BtnLiquid from '../components/BtnLiquid'
import { useMedia } from 'react-use'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import globals from '../globals'
import HighlightText from '../components/HighlightText'

gsap.registerPlugin(ScrollToPlugin)
window.requestAnimationFrame = window.requestAnimationFrame.bind(window) // Reqd for IE Edge in dev
gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(SplitText)

const BannerNbn = (props) => {
    const isExtraLargeScreen = useMedia('(min-width: 1500px)')
    const frame2 = useRef(null)
    const heading2 = useRef(null)
    const subHeading2 = useRef(null)
    const copy2 = useRef(null)
    const terms2 = useRef(null)

    useEffect(() => {
        globals.pushGA4Events('journeyStep', {
            eventInfo: {
                journeyName: 'Nbn Plans',
                stepName: 'Load page',
                stepNo: '1'
            }
        })
    }, [])

    const handleClickCta = (event, name) => {
        globals.pushGA4Events('journeyStep', {
            eventInfo: {
                journeyName: 'NBN Plans',
                stepName: 'Start with your address',
                stepNo: '2'
            }
        })

        globals.pushGA4Events('bannerCtaClick', {
            eventInfo: {
                clickText: name ? name : "View nbn Plans",
                clickUrl: window.location.href,
                pageCategory: 'Residential'
            }
        })
        event.preventDefault()
        gsap.to(window, { duration: 1, scrollTo: { y: document.getElementById('sq-field-trigger'), offsetY: 120 } })
    }
    return (
        <div className='hero-banner-nbn'>
            <div className='mobile-spacer' />
            <div className='inner'>
                <div className='row'>
                    <div className={`col-12 col-lg-7 col-xl-5 ${isExtraLargeScreen ? 'offset-lg-1' : ''}`}>
                        <div className='row mb-3 mb-lg-4 ml-lg-1'>
                            <div className='col-12'>
                                <div ref={frame2} className='frame-2 text-center'>
                                    <div className='hero-text'>
                                        <img src='/images/winner-reef-left.svg' alt='Winner left' />
                                        <div>
                                            <h1 className='my-0 mx-auto'>
                                                <span ref={heading2} className='d-inline-block text-nowrap'>
                                                    Award-winning home<br/> internet with nbn®<br/> plans from $55/mth 
                                                </span>
                                            </h1>
                                        </div>
                                        <img src='/images/winner-reef-right.svg' alt='Winner right' />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row no-gutters'>
                            <div className='col-12 text-lg-center'>
                                <BtnLiquid color='spearmint' className='mr-3' handleClick={handleClickCta}>View nbn™ plans</BtnLiquid>
                                <BtnLiquid color='offBlue' handleClick={(event) => handleClickCta(event, 'Check address')}>Check address</BtnLiquid>
                            </div>
                        </div>
                        <div className={`mt-4 award ${isExtraLargeScreen ? 'pt-3' : ''}`}>
                            <img src='/images/awards/badges-awards.svg' alt='Exetel - Canstar Innovation Excellence 2022' />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BannerNbn



// WEBPACK FOOTER //
// ./resources/js/banners/BannerNbn.js